const THB = new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export function money(satang: number, opts: { compact?: boolean; symbol?: boolean } = {}): string {
  const { compact = false, symbol = true } = opts
  const baht = satang / 100
  if (compact && Math.abs(baht) >= 1_000_000) return `${symbol ? '฿' : ''}${(baht / 1_000_000).toFixed(2)}M`
  if (compact && Math.abs(baht) >= 10_000) return `${symbol ? '฿' : ''}${(baht / 1_000).toFixed(0)}K`
  const s = THB.format(Math.abs(baht))
  const signed = baht < 0 ? `(${s})` : s
  return symbol ? `฿${signed}` : signed
}

export function number(n: number): string {
  return new Intl.NumberFormat('th-TH').format(n)
}

const TH_MONTHS = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']

// Postgres renders short offsets ("+07"); Date() only accepts "+07:00". Normalise first,
// otherwise every store that uses to_char(..., 'OF') produces NaN on screen.
function parseISO(iso: string): Date {
  // Only timestamps carry a UTC offset; a plain date like 2026-11-03 must not be mistaken for
  // one ("-03" is not a timezone). Patch the offset only when a time component is present.
  return new Date(iso.includes('T') ? iso.replace(/([+-]\d{2})$/, '$1:00') : iso)
}

export function thaiDate(iso: string): string {
  const d = parseISO(iso)
  return `${d.getDate()} ${TH_MONTHS[d.getMonth()]} ${d.getFullYear() + 543}`
}

export function thaiDateTime(iso: string): string {
  const d = parseISO(iso)
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  return `${thaiDate(iso)} · ${hh}:${mm}`
}

export function pct(v: number): string {
  return `${(v * 100).toFixed(0)}%`
}

export function riskTone(score: number): string {
  if (score >= 80) return 'sev-critical'
  if (score >= 60) return 'sev-high'
  if (score >= 35) return 'sev-medium'
  return 'sev-low'
}
